import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useUser } from '../context/UserContext';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useUser();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');

  try {
    console.log('📤 Sending login request to backend:', {
      url: '/api/admin/login',
      data: formData
    });

    const response = await axios.post('/api/admin/login', formData);
    
    console.log('📥 Response received from backend:', {
      status: response.status,
      statusText: response.statusText,
      data: response.data
    });

    if (response.data.success) {
      console.log('✅ Login successful, logging in user...');
      login(response.data.user, response.data.token, true);
      
      if (response.data.user.role === 'admin') {
        console.log('👉 Redirecting to admin dashboard');
        navigate('/admin/dashboard');
      } else if (response.data.user.role === 'partner') {
        console.log('👉 Redirecting to partner dashboard');
        navigate('/partner/dashboard');
      }
    } else {
      console.log('❌ Login failed:', response.data.message);
      setError(response.data.message || 'Login failed');
    }
  } catch (error) {
    console.error('❌❌❌ Frontend error details:');
    console.error('Error object:', error);
    console.error('Response status:', error.response?.status);
    console.error('Response data:', error.response?.data);
    console.error('Error message:', error.message);
    
    setError(error.response?.data?.message || 'Login failed');
  } finally {
    setLoading(false);
  }
};

  return (
    <section className="admin-login py-80">
      <div className="container container-lg">
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6">
            <div className="text-center mb-40">
              <h1 className="mb-16">Admin Login</h1>
              <p className="text-gray-500">Access your dashboard</p>
            </div>

            {error && (
              <div className="alert alert-danger mb-24">{error}</div>
            )}

            <div className="border rounded-16 p-40 bg-white">
              <form onSubmit={handleSubmit}>
                <div className="mb-24">
                  <label className="form-label fw-medium">Username or Email</label>
                  <input
                    type="text"
                    name="username"
                    className="form-control"
                    value={formData.username}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-24">
                  <label className="form-label fw-medium">Password</label>
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-main w-100 py-16"
                  disabled={loading}
                >
                  {loading ? 'Logging in...' : 'Login'}
                </button>
              </form>

              <div className="text-center mt-24">
                <Link to="/" className="text-main-600">
                  ← Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminLogin;